import { useState, useEffect, useRef } from "react";
const Reviews = () => {
      const reviews = [
    {
      name: "Sarah Jenkins",
      designation: "Verified Buyer",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&h=150&auto=format&fit=crop",
      text: "Finally, a pad that doesn't feel like plastic! The organic cotton is so gentle on my sensitive skin.",
    },
    {
      name: "Dr. Ananya Rao",
      designation: "Gynaecologist",
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=150&h=150&auto=format&fit=crop",
      text: "I highly recommend HerFlow to my patients. The pH-balanced materials are a game changer for health.",
    },
    {
      name: "Priya Sharma",
      designation: "Yoga Instructor",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=150&h=150&auto=format&fit=crop",
      text: "The Ultra-Thin pads stay in place even during my most intense sessions. Zero leaks, total confidence.",
    },
    {
      name: "Emily Watson",
      designation: "Eco-Conscious Traveler",
      image:
        "https://images.unsplash.com/photo-1554151228-14d9def656e4?q=80&w=150&h=150&auto=format&fit=crop",
      text: "I love that these are biodegradable. It feels good to have a period that doesn't hurt the planet.",
    },
    {
      name: "Maya Stevens",
      designation: "Mother of Two",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&h=150&auto=format&fit=crop",
      text: "Bought the Starter Kit for my daughter. It made a scary moment feel like a self-care celebration.",
    },
    {
      name: "Jessica Lee",
      designation: "Night Shift Nurse",
      image:
        "https://images.unsplash.com/photo-1559839734-2b71f1536783?q=80&w=150&h=150&auto=format&fit=crop",
      text: "The Overnight Max protection is the only thing that lets me work 12-hour shifts without worry.",
    },
    {
      name: "Sophia Martinez",
      designation: "Fitness Athlete",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=150&h=150&auto=format&fit=crop",
      text: "Breathable, soft, and high-absorbency. It’s like I’m not even wearing anything. Simply amazing!",
    },
    {
      name: "Chloe Bennett",
      designation: "Subscription Member",
      image:
        "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=150&h=150&auto=format&fit=crop",
      text: "The monthly box is a lifesaver. It arrives like clockwork. No more late-night store runs!",
    },
    {
      name: "Rachel Green",
      designation: "Postpartum Mom",
      image:
        "https://images.unsplash.com/photo-1554151228-14d9def656e4?q=80&w=150&h=150&auto=format&fit=crop",
      text: "The high-absorbency range was so much softer than hospital pads. It made recovery easier.",
    },
    {
      name: "Liam Scott",
      designation: "Gift Buyer",
      image:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&h=150&auto=format&fit=crop",
      text: "Bought a wellness bundle for my wife. She loved the heating patches and the premium quality.",
    },
  ];
  const reviewsContainerRef = useRef(null);
    useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    
    // Auto-scroll reviews logic
    const container = reviewsContainerRef.current;
    let scrollAmount = 0;
    const interval = setInterval(() => {
      if (container) {
        container.scrollLeft += 1;
        scrollAmount += 1;
        if (scrollAmount >= container.scrollWidth - container.clientWidth) {
          container.scrollLeft = 0;
          scrollAmount = 0;
        }
      }
    }, 200);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="w-[80%] mx-auto">
         <div className="text-center mb-12 px-4 md:px-8">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600">Testimonials from our happy clients</p>
        </div>

        <div
          ref={reviewsContainerRef}
          className="flex gap-6 px-4 md:px-8 overflow-x-auto scrollbar-hide pb-12"
        >
          {reviews.map((review, idx) => (
            <div key={idx} className="flex-shrink-0 w-80 md:w-96 p-6 rounded-3xl shadow-lg border border-pink-100 bg-white">
               {/* ... Your Review Content ... */}
               <p className="text-gray-600 italic">"{review.text}"</p>
               <div className="mt-4 flex items-center gap-3">
                  <img src={review.image} className="w-12 h-12 rounded-full" alt="" />
                  <span className="font-bold text-gray-800">{review.name}</span>
               </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default Reviews